(() => {
  const config = window.idrDisplayConverter || {};
  const currentCountry = (config.currentCountry || '').toUpperCase();
  const shopCurrency = (config.shopCurrency || 'USD').toUpperCase();

  // Country ISO -> local display currency
  const COUNTRY_CURRENCY = {
    US: { currency: 'USD', symbol: '$', locale: 'en-US', decimals: 2 },
    PR: { currency: 'USD', symbol: '$', locale: 'en-US', decimals: 2 },
    AU: { currency: 'AUD', symbol: 'A$', locale: 'en-AU', decimals: 2, fallbackRate: 1.55 },
    ID: { currency: 'IDR', symbol: 'Rp', locale: 'id-ID', decimals: 0, fallbackRate: 16200 },
    GB: { currency: 'GBP', symbol: '£', locale: 'en-GB', decimals: 2, fallbackRate: 0.79 },
    CA: { currency: 'CAD', symbol: 'C$', locale: 'en-CA', decimals: 2, fallbackRate: 1.38 },
    NZ: { currency: 'NZD', symbol: 'NZ$', locale: 'en-NZ', decimals: 2, fallbackRate: 1.68 },
    JP: { currency: 'JPY', symbol: '¥', locale: 'ja-JP', decimals: 0, fallbackRate: 150 },
    CN: { currency: 'CNY', symbol: '¥', locale: 'zh-CN', decimals: 2, fallbackRate: 7.2 },
    HK: { currency: 'HKD', symbol: 'HK$', locale: 'zh-HK', decimals: 2, fallbackRate: 7.8 },
    SG: { currency: 'SGD', symbol: 'S$', locale: 'en-SG', decimals: 2, fallbackRate: 1.35 },
    MY: { currency: 'MYR', symbol: 'RM', locale: 'ms-MY', decimals: 2, fallbackRate: 4.7 },
    TH: { currency: 'THB', symbol: '฿', locale: 'th-TH', decimals: 2, fallbackRate: 36 },
    PH: { currency: 'PHP', symbol: '₱', locale: 'en-PH', decimals: 2, fallbackRate: 58 },
    VN: { currency: 'VND', symbol: '₫', locale: 'vi-VN', decimals: 0, fallbackRate: 25000 },
    IN: { currency: 'INR', symbol: '₹', locale: 'en-IN', decimals: 2, fallbackRate: 83 },
    KR: { currency: 'KRW', symbol: '₩', locale: 'ko-KR', decimals: 0, fallbackRate: 1350 },
    TW: { currency: 'TWD', symbol: 'NT$', locale: 'zh-TW', decimals: 2, fallbackRate: 32 },
    AT: { currency: 'EUR', symbol: '€', locale: 'de-AT', decimals: 2, fallbackRate: 0.92 },
    BE: { currency: 'EUR', symbol: '€', locale: 'fr-BE', decimals: 2, fallbackRate: 0.92 },
    DE: { currency: 'EUR', symbol: '€', locale: 'de-DE', decimals: 2, fallbackRate: 0.92 },
    ES: { currency: 'EUR', symbol: '€', locale: 'es-ES', decimals: 2, fallbackRate: 0.92 },
    FI: { currency: 'EUR', symbol: '€', locale: 'fi-FI', decimals: 2, fallbackRate: 0.92 },
    FR: { currency: 'EUR', symbol: '€', locale: 'fr-FR', decimals: 2, fallbackRate: 0.92 },
    IE: { currency: 'EUR', symbol: '€', locale: 'en-IE', decimals: 2, fallbackRate: 0.92 },
    IT: { currency: 'EUR', symbol: '€', locale: 'it-IT', decimals: 2, fallbackRate: 0.92 },
    NL: { currency: 'EUR', symbol: '€', locale: 'nl-NL', decimals: 2, fallbackRate: 0.92 },
    PT: { currency: 'EUR', symbol: '€', locale: 'pt-PT', decimals: 2, fallbackRate: 0.92 },
    GR: { currency: 'EUR', symbol: '€', locale: 'el-GR', decimals: 2, fallbackRate: 0.92 },
    HR: { currency: 'EUR', symbol: '€', locale: 'hr-HR', decimals: 2, fallbackRate: 0.92 },
    CY: { currency: 'EUR', symbol: '€', locale: 'el-CY', decimals: 2, fallbackRate: 0.92 },
    EE: { currency: 'EUR', symbol: '€', locale: 'et-EE', decimals: 2, fallbackRate: 0.92 },
    LV: { currency: 'EUR', symbol: '€', locale: 'lv-LV', decimals: 2, fallbackRate: 0.92 },
    LT: { currency: 'EUR', symbol: '€', locale: 'lt-LT', decimals: 2, fallbackRate: 0.92 },
    LU: { currency: 'EUR', symbol: '€', locale: 'fr-LU', decimals: 2, fallbackRate: 0.92 },
    MT: { currency: 'EUR', symbol: '€', locale: 'mt-MT', decimals: 2, fallbackRate: 0.92 },
    SI: { currency: 'EUR', symbol: '€', locale: 'sl-SI', decimals: 2, fallbackRate: 0.92 },
    SK: { currency: 'EUR', symbol: '€', locale: 'sk-SK', decimals: 2, fallbackRate: 0.92 },
    CH: { currency: 'CHF', symbol: 'CHF', locale: 'de-CH', decimals: 2, fallbackRate: 0.88 },
    SE: { currency: 'SEK', symbol: 'kr', locale: 'sv-SE', decimals: 2, fallbackRate: 10.5 },
    NO: { currency: 'NOK', symbol: 'kr', locale: 'nb-NO', decimals: 2, fallbackRate: 10.7 },
    DK: { currency: 'DKK', symbol: 'kr', locale: 'da-DK', decimals: 2, fallbackRate: 6.9 },
    PL: { currency: 'PLN', symbol: 'zł', locale: 'pl-PL', decimals: 2, fallbackRate: 4.0 },
    CZ: { currency: 'CZK', symbol: 'Kč', locale: 'cs-CZ', decimals: 2, fallbackRate: 23 },
    HU: { currency: 'HUF', symbol: 'Ft', locale: 'hu-HU', decimals: 0, fallbackRate: 360 },
    RO: { currency: 'RON', symbol: 'lei', locale: 'ro-RO', decimals: 2, fallbackRate: 4.6 },
    BG: { currency: 'BGN', symbol: 'лв', locale: 'bg-BG', decimals: 2, fallbackRate: 1.8 },
    TR: { currency: 'TRY', symbol: '₺', locale: 'tr-TR', decimals: 2, fallbackRate: 32 },
    UA: { currency: 'UAH', symbol: '₴', locale: 'uk-UA', decimals: 2, fallbackRate: 41 },
    RU: { currency: 'RUB', symbol: '₽', locale: 'ru-RU', decimals: 2, fallbackRate: 92 },
    BR: { currency: 'BRL', symbol: 'R$', locale: 'pt-BR', decimals: 2, fallbackRate: 5.0 },
    MX: { currency: 'MXN', symbol: 'MX$', locale: 'es-MX', decimals: 2, fallbackRate: 17 },
    AR: { currency: 'ARS', symbol: 'AR$', locale: 'es-AR', decimals: 2, fallbackRate: 900 },
    CL: { currency: 'CLP', symbol: 'CL$', locale: 'es-CL', decimals: 0, fallbackRate: 950 },
    CO: { currency: 'COP', symbol: 'COL$', locale: 'es-CO', decimals: 0, fallbackRate: 4000 },
    PE: { currency: 'PEN', symbol: 'S/', locale: 'es-PE', decimals: 2, fallbackRate: 3.7 },
    ZA: { currency: 'ZAR', symbol: 'R', locale: 'en-ZA', decimals: 2, fallbackRate: 18 },
    NG: { currency: 'NGN', symbol: '₦', locale: 'en-NG', decimals: 2, fallbackRate: 1500 },
    EG: { currency: 'EGP', symbol: 'E£', locale: 'ar-EG', decimals: 2, fallbackRate: 48 },
    KE: { currency: 'KES', symbol: 'KSh', locale: 'en-KE', decimals: 2, fallbackRate: 130 },
    AE: { currency: 'AED', symbol: 'AED', locale: 'ar-AE', decimals: 2, fallbackRate: 3.67 },
    SA: { currency: 'SAR', symbol: 'SAR', locale: 'ar-SA', decimals: 2, fallbackRate: 3.75 },
    QA: { currency: 'QAR', symbol: 'QAR', locale: 'ar-QA', decimals: 2, fallbackRate: 3.64 },
    KW: { currency: 'KWD', symbol: 'KD', locale: 'ar-KW', decimals: 3, fallbackRate: 0.31 },
    BH: { currency: 'BHD', symbol: 'BD', locale: 'ar-BH', decimals: 3, fallbackRate: 0.38 },
    IL: { currency: 'ILS', symbol: '₪', locale: 'he-IL', decimals: 2, fallbackRate: 3.7 },
    PK: { currency: 'PKR', symbol: 'Rs', locale: 'en-PK', decimals: 2, fallbackRate: 278 },
    BD: { currency: 'BDT', symbol: '৳', locale: 'bn-BD', decimals: 2, fallbackRate: 110 },
    LK: { currency: 'LKR', symbol: 'Rs', locale: 'si-LK', decimals: 2, fallbackRate: 300 },
    NP: { currency: 'NPR', symbol: 'Rs', locale: 'ne-NP', decimals: 2, fallbackRate: 133 },
  };

  const configuredMarkets = config.markets || {};
  const availableCountries = Array.isArray(config.availableCountries)
    ? config.availableCountries.map((c) => String(c).toUpperCase())
    : Object.keys(COUNTRY_CURRENCY);

  function buildMarket(countryCode, extra) {
    const base = COUNTRY_CURRENCY[countryCode] || null;
    if (!base && !(extra && extra.currency)) return null;
    const merged = Object.assign({}, base || {}, extra || {});
    if (!merged.currency) return null;
    if (!merged.symbol) merged.symbol = merged.currency;
    if (!Number.isFinite(merged.decimals)) merged.decimals = 2;
    merged.label = merged.label || `${merged.currency} ${merged.symbol}`;
    return merged;
  }

  const markets = {};
  availableCountries.forEach((countryCode) => {
    const market = buildMarket(countryCode, configuredMarkets[countryCode]);
    if (market) markets[countryCode] = market;
  });
  Object.keys(configuredMarkets).forEach((countryCode) => {
    if (!markets[countryCode]) {
      const market = buildMarket(countryCode, configuredMarkets[countryCode]);
      if (market) markets[countryCode] = market;
    }
  });

  const market = markets[currentCountry] || null;

  const noticeTemplate =
    config.noticeTemplate ||
    'Prices are shown in {{ currency }} for reference. Checkout and payment remain in USD.';

  const RATE_CACHE_TTL = 1000 * 60 * 60 * 12;
  let rate = market ? Number(market.fallbackRate) || 1 : 1;
  let converting = false;

  const moneySelectors = [
    '[data-money]',
    '.price-item',
    '.totals__subtotal-value',
    '.cart-item__final-price',
    '.cart-item__old-price',
    '.cart-item__price',
    '.free-shipping-bar__meta-current',
    '.free-shipping-bar__meta-goal',
  ].join(',');

  function formatMoney(amount) {
    const decimals = Number.isFinite(market.decimals) ? market.decimals : 2;
    const value =
      decimals === 0 ? Math.round(amount) : Number(amount.toFixed(decimals));

    return (
      market.symbol +
      value.toLocaleString(market.locale || undefined, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      })
    );
  }

  function centsToShopAmount(cents) {
    return Number(cents) / 100;
  }

  function parseMoneyText(text) {
    if (!text) return null;
    const cleaned = String(text)
      .replace(/[^\d.,-]/g, '')
      .trim();
    if (!cleaned) return null;

    const hasComma = cleaned.includes(',');
    const hasDot = cleaned.includes('.');
    let normalized = cleaned;

    if (hasComma && hasDot) {
      if (cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
        normalized = cleaned.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = cleaned.replace(/,/g, '');
      }
    } else if (hasComma && !hasDot) {
      const parts = cleaned.split(',');
      normalized =
        parts.length === 2 && parts[1].length <= 2
          ? cleaned.replace(',', '.')
          : cleaned.replace(/,/g, '');
    }

    const value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : null;
  }

  function rateCacheKey() {
    return `display_fx_${shopCurrency}_${market.currency}`;
  }

  function getCachedRate() {
    try {
      const raw = sessionStorage.getItem(rateCacheKey());
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.rate || !parsed.expires) return null;
      if (Date.now() > parsed.expires) return null;
      return Number(parsed.rate);
    } catch (e) {
      return null;
    }
  }

  function setCachedRate(value) {
    try {
      sessionStorage.setItem(
        rateCacheKey(),
        JSON.stringify({
          rate: value,
          expires: Date.now() + RATE_CACHE_TTL,
        })
      );
    } catch (e) {
      // ignore storage errors
    }
  }

  async function fetchRateFromApi() {
    const endpoints = [
      `https://open.er-api.com/v6/latest/${encodeURIComponent(shopCurrency)}`,
      `https://api.frankfurter.app/latest?from=${encodeURIComponent(
        shopCurrency
      )}&to=${encodeURIComponent(market.currency)}`,
    ];

    for (const url of endpoints) {
      try {
        const response = await fetch(url);
        if (!response.ok) continue;
        const data = await response.json();
        const nextRate = Number(
          (data && data.rates && data.rates[market.currency]) ||
            (data && data.rates && data.rates[market.currency])
        );
        if (Number.isFinite(nextRate) && nextRate > 0) return nextRate;
      } catch (e) {
        // try next endpoint
      }
    }
    return null;
  }

  async function loadRate() {
    if (!market) return null;
    if (shopCurrency === market.currency) {
      rate = 1;
      return rate;
    }

    const cached = getCachedRate();
    if (cached) {
      rate = cached;
      return rate;
    }

    const nextRate = await fetchRateFromApi();
    if (nextRate) {
      rate = nextRate;
      setCachedRate(rate);
    } else {
      rate = Number(market.fallbackRate) || rate;
    }

    return rate;
  }

  function ensureOriginal(el) {
    if (!el.hasAttribute('data-money-original')) {
      el.setAttribute('data-money-original', el.innerHTML);
    }
  }

  function convertElement(el) {
    if (!market) return;
    if (!(el instanceof HTMLElement)) return;
    if (el.closest('[data-idr-skip], [data-fx-skip]')) return;
    if (el.matches('input, textarea, select')) return;

    const moneyAttr = el.getAttribute('data-money');
    let shopAmount = null;
    const convertedAttr = 'data-fx-converted';
    const centsAttr = 'data-fx-cents';
    const parsedAttr = 'data-fx-parsed';

    if (moneyAttr != null && moneyAttr !== '') {
      const stamped = el.getAttribute(centsAttr);
      if (el.getAttribute(convertedAttr) === 'true' && stamped === moneyAttr) {
        return;
      }
      shopAmount = centsToShopAmount(moneyAttr);
      el.setAttribute(centsAttr, moneyAttr);
    } else {
      ensureOriginal(el);
      const original = el.getAttribute('data-money-original') || el.textContent;
      shopAmount = parseMoneyText(original);
      if (
        el.getAttribute(convertedAttr) === 'true' &&
        el.getAttribute(parsedAttr) === String(shopAmount)
      ) {
        return;
      }
      el.setAttribute(parsedAttr, String(shopAmount));
    }

    if (shopAmount == null) return;

    ensureOriginal(el);

    const convertedAmount = shopAmount * rate;
    const formatted = formatMoney(convertedAmount);
    const fromPrefix = el.getAttribute('data-money-from') === 'true';

    if (fromPrefix) {
      const fromLabel = config.fromLabel || 'From';
      el.textContent = `${fromLabel} ${formatted}`;
    } else {
      el.textContent = formatted;
    }

    el.setAttribute(convertedAttr, 'true');
    el.setAttribute('data-idr-converted', 'true');
  }

  function updateLocalizationLabels() {
    Object.keys(markets).forEach((countryCode) => {
      const entry = markets[countryCode];
      const label = entry.label || `${entry.currency} ${entry.symbol}`;

      document
        .querySelectorAll(
          `.disclosure__link[data-value="${countryCode}"] .localization-form__currency`
        )
        .forEach((el) => {
          el.textContent = `(${label})`;
        });

      document
        .querySelectorAll(`option[value="${countryCode}"]`)
        .forEach((el) => {
          const name = el.textContent.split('(')[0].trim();
          el.textContent = `${name} (${label})`;
        });
    });

    if (market) {
      document.querySelectorAll('.currency-symbol').forEach((el) => {
        el.textContent = `(${market.symbol})`;
      });
    }
  }

  function ensureNotices() {
    if (!market || shopCurrency === market.currency) return;

    const noticeText = noticeTemplate.replace(
      /\{\{\s*currency\s*\}\}/g,
      market.currency
    );

    function upsertNotice(container, referenceEl) {
      if (!container) return;

      const existing = Array.from(
        container.querySelectorAll('.idr-checkout-notice')
      );
      let notice = existing[0] || null;
      existing.slice(1).forEach((el) => el.remove());

      if (!notice) {
        notice = document.createElement('p');
        notice.className = 'idr-checkout-notice';
        notice.setAttribute('role', 'note');

        if (referenceEl && referenceEl.parentElement === container) {
          container.insertBefore(notice, referenceEl);
        } else if (referenceEl) {
          referenceEl.insertAdjacentElement('afterend', notice);
        } else {
          container.appendChild(notice);
        }
      }

      notice.textContent = noticeText;
    }

    const cartDrawerBottom = document.querySelector('.cart-drawer__bottom');
    upsertNotice(
      cartDrawerBottom,
      cartDrawerBottom && cartDrawerBottom.querySelector('.cart__ctas')
    );

    const cartFooter = document.querySelector('#main-cart-footer');
    upsertNotice(
      cartFooter,
      cartFooter && cartFooter.querySelector('.cart__ctas')
    );

    const priceTargets = [
      ...document.querySelectorAll(
        'quick-add-modal .product__info-container .price, quick-add-modal .price-wrapper .price, quick-add-modal .product .price'
      ),
      document.querySelector('product-info .price'),
      document.querySelector('.product__info-container .price'),
      document.querySelector('.product__title + .price'),
    ].filter(Boolean);

    const seen = new Set();
    priceTargets.forEach((priceEl) => {
      if (seen.has(priceEl)) return;
      seen.add(priceEl);
      const host = priceEl.parentElement;
      if (!host) return;

      const existing = Array.from(
        host.querySelectorAll(':scope > .idr-checkout-notice')
      );
      let notice = existing[0] || null;
      existing.slice(1).forEach((el) => el.remove());

      if (!notice) {
        notice = document.createElement('p');
        notice.className = 'idr-checkout-notice';
        notice.setAttribute('role', 'note');
        priceEl.insertAdjacentElement('afterend', notice);
      }
      notice.textContent = noticeText;
    });
  }

  function convertAll(root = document) {
    if (converting) return;
    converting = true;
    try {
      updateLocalizationLabels();
      if (market && shopCurrency !== market.currency) {
        root.querySelectorAll(moneySelectors).forEach(convertElement);
        ensureNotices();
        document.documentElement.classList.add('idr-display-active');
        document.documentElement.setAttribute(
          'data-display-currency',
          market.currency
        );
      }
    } finally {
      converting = false;
    }
  }

  function observeDom() {
    if (!market || shopCurrency === market.currency) return;

    let scheduled = false;
    const observer = new MutationObserver((mutations) => {
      if (converting || scheduled) return;
      const shouldUpdate = mutations.some((mutation) => {
        if (mutation.type === 'characterData') {
          const parent = mutation.target.parentElement;
          return (
            parent &&
            parent.getAttribute('data-fx-converted') !== 'true' &&
            parent.getAttribute('data-idr-converted') !== 'true'
          );
        }
        return Array.from(mutation.addedNodes).some(
          (node) =>
            node.nodeType === 1 &&
            (node.matches?.(moneySelectors) ||
              node.querySelector?.(moneySelectors))
        );
      });
      if (shouldUpdate) {
        scheduled = true;
        window.requestAnimationFrame(() => {
          scheduled = false;
          convertAll();
        });
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  async function init() {
    updateLocalizationLabels();
    if (market && shopCurrency !== market.currency) {
      await loadRate();
      convertAll();
      observeDom();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
